export const groupsTableOptions = (t) => {
  return [
    { title: t("IDENTIFIER"), name: "skracenica", width: 2 },
    { title: t("NAME_1"), name: "naziv", width: 3 },
    { title: t("DESCRIPTION"), name: "opis", width: 8 },
    // { title: t("STATUS"), name: "status", width: 3 },
  ];
};
export const usersTableOptions = (t) => {
  return [
    { title: t("GROUP"), name: "grupa", width: 1.5 },
    { title: t("FULL_NAME"), name: "celo_ime", width: 5 },
    { title: t("ENTITY"), name: "entitet", width: 4.0 },
    { title: t("PHONE"), name: "telefon", width: 3.6 },
    { title: t("EMAIL"), name: "email", width: 4 },
    // { title: t("STATUS"), name: "status", width: 2 },
  ];
};
export const eventsTableOptionsFirst = (t) => {
  return [
    {
      title: t("START"),
      name: "trajanje_od",
      width: 2,
    },
    {
      title: t("DURATION"),
      name: "trajanje",
      width: 1.2,
    },
    { title: t("NAME_1"), name: "naziv", width: 8 },
    {
      title: t("PROCESED_APPLIED"),
      name: "procesuirano_obradjeno",
      width: 1,
    },
  ];
};

export const eventsTableOptionsSecond = (t) => {
  return [
    {
      title: t("START"),
      name: "trajanje_od",
      width: 2,
    },
    {
      title: t("DURATION"),
      name: "trajanje",
      width: 1.2,
    },
    { title: t("NAME_1"), name: "naziv", width: 8 },
    {
      title: t("PROCESED_APPLIED"),
      name: "procesuirano_obradjeno",
      width: 1,
    },
  ];
};

export const eventsTableOptionsThird = (t) => {
  return [
    { title: t("START"), name: "trajanje_od", width: 1.2 },
    { title: t("DURATION"), name: "trajanje", width: 0.8 },
    { title: t("NAME_1"), name: "naziv", width: 4 },
    {
      title: t("PROCESED_APPLIED"),
      name: "procesuirano_obradjeno",
      width: 1,
    },
    { title: t("ACTIONS"), name: "actions", width: 1 },
  ];
};

export const registeredTableOptionsFirst = (t) => {
  return [
    { title: t("PICTURE"), name: "slika_avatar", width: 1 },
    {
      title: t("FULL_NAME"),
      name: "ime",
      width: 5,
    },
    {
      title: t("POSITION"),
      name: "pozicija",
      width: 4,
    },
    {
      title: t("EMAIL"),
      name: "email",
      width: 4,
    },
    {
      title: t("STATUS"),
      name: "status",
      width: 2,
    },
    {
      title: t("DOWNLOAD"),
      name: "download",
      width: 2,
    },
  ];
};

export const registeredTableOptionsSecond = (t) => {
  return [
    { title: t("PICTURE"), name: "slika_avatar", width: 1 },
    { title: "", name: "drzavljanstvo", width: 1 },
    {
      title: t("DOCUMENT_NUMBER"),
      name: "broj_dokumenta",
      width: 3,
    },
    {
      title: t("DOCUMENT_TYPE"),
      name: "tip_dokumenta",
      width: 2,
    },
    {
      title: t("FULL_NAME"),
      name: "ime",
      width: 5,
    },
    {
      title: t("ENTITY"),
      name: "entitet",
      width: 3,
    },
    {
      title: t("STATUS"),
      name: "status",
      width: 2,
    },
    {
      title: t("ACTIONS"),
      name: "actions",
      width: 1,
    },
  ];
};

export const registeredTableOptionsThird = (t) => {
  return [
    { title: t("PICTURE"), name: "slika_avatar", width: 1 },
    {
      title: t("FULL_NAME"),
      name: "ime",
      width: 5,
    },
    {
      title: t("GROUP"),
      name: "dogadjaj_grupa",
      width: 1,
    },
    {
      title: "",
      name: "drzavljanstvo",
      width: 1,
    },
    // Entitet with the person's pozicija on a second line (PersonsPanel
    // passes it as rowData.pozicijaSub; TableRow renders both).
    {
      title: `${t("ENTITY")} / ${t("POSITION")}`,
      name: "entitet",
      width: 5,
    },
    // createdAt, kept as ISO so sorting is chronological; TableRow formats it.
    {
      title: t("SUBMISSION_DATE"),
      name: "datum_prijave",
      width: 3,
    },
    {
      title: t("SUGGESTION"),
      name: "predlozi",
      width: 2,
    },
    {
      title: t("STATUS"),
      name: "status",
      width: 2,
    },
    {
      title: t("ACCREDITATION"),
      name: "accreditation",
      width: 2,
    },
  ];
};

export const usersFromGroupTableOptions = (t) => {
  return [
    {
      title: t(""),
      name: "checkbox",
      width: 3,
    },
    {
      title: t("FULL_NAME"),
      name: "celo_ime",
      width: 10,
    },
    { title: t("ENTITY"), name: "entitet", width: 3.0 },
    { title: t("GROUP"), name: "grupa", width: 3.0 },
    {
      title: t("PHONE"),
      name: "telefon",
      width: 5,
    },
  ];
};

export const eventGroupsOptions = (t) => {
  return [
    {
      title: t("IDENTIFIER"),
      name: "skracenica",
      width: 2.5,
    },
    {
      title: t("NAME_1"),
      name: "naziv",
      width: 5,
    },
    {
      title: t("DESCRIPTION"),
      name: "opis",
      width: 5,
    },
    {
      title: t("ACTIONS"),
      name: "actions_3",
      width: 1,
    },
    {
      title: t(""),
      name: "children",
      width: 0,
    },
  ];
};

export const eventUsersOptions = (t) => {
  return [
    {
      title: t("NAME"),
      name: "celo_ime",
      width: 5,
    },
    {
      title: t("ENTITY"),
      name: "entitet",
      width: 4,
    },
    {
      title: t("EVENT_GROUP"),
      name: "dogadjaj_grupa",
      width: 5,
    },
    {
      title: t("PHONE"),
      name: "telefon",
      width: 5,
    },
    {
      title: t("SYSTEM_GROUP"),
      name: "grupa",
      width: 5,
    },
    {
      title: t("ACTIONS"),
      name: "actions_2",
      width: 1,
    },
  ];
};
export const emailTemplates = (t) => {
  return [
    {
      title: t("NAME_1"),
      name: "naziv",
      width: 2,
    },
    {
      title: t("SUBJECT"),
      name: "subject",
      width: 2,
    },
    {
      title: t("CONTENT"),
      name: "textBody",
      width: 5,
    },
  ];
};

export const vehiclesTableOptions = (t) => {
  return [
    {
      title: t("VEHICLE_TYPE"),
      name: "tip",
      width: 2,
    },
    {
      title: t("REGISTRATION"),
      name: "registracija",
      width: 2,
    },
    {
      title: t("ENTITY"),
      name: "entitet",
      width: 3,
    },
    {
      title: t("BRAND"),
      name: "marka",
      width: 2,
    },
    {
      title: t("MODEL"),
      name: "model",
      width: 2,
    },
    {
      title: t("ACTIONS"),
      name: "actions",
      width: 1,
    },
  ];
};
